<script>
import CompactElementUi from './Compact-Element-Ui.vue'
import GenerateReport from '../GenerateReport.vue'
import GenerateInline from './GenerateInline'
import GenerateColItem from './GenerateColItem'
import GenerateTabItem from './GenerateTabItem'
import GenerateCollapse from './GenerateCollapse'

export default {
	extends: GenerateReport,
	components: {
		GenerateFormItem: () => import('./GenerateFormItem.vue'),
		GenerateInline,
		GenerateColItem,
		GenerateTabItem,
		GenerateCollapse
	},
	mixins: [CompactElementUi]
}
</script>
